import { render } from "./AppError_401.vue?vue&type=template&id=4b71b4db"
import script from "./AppError_401.vue?vue&type=script&lang=js"
export * from "./AppError_401.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__